import React from "react";

import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import {
  ProgressBar,
  makeStyles,
  shorthands,
  Label,
  typographyStyles,
  Text,
  Spinner,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  container: {
    ...shorthands.margin("20px", "0px"),
  },
  root: {
    fontSize: "21px",
    fontWeight: "bold",
    color: "var(--accent-color-1)",
  },
  underRoot: {
    fontSize: "15px",

    color: "var(--primary-color)",
  },
  title: {
    ...typographyStyles.subtitle1,
    color: "var(--primary-color)",
    textAlign: "center",
  },
});

const MultiStepFormforUnSuccess = ({
  step: initialStep,
  isStepCompleted,
  savedData,
  loading,
}) => {
  const totalSteps = 3;
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div style={{ width: "100%", margin: "0 auto", paddingTop: "20px" }}>
      {/* Grey background overlay while loading */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Spinner component */}
          <Spinner size="large" label="Loading..." />
        </div>
      )}
      <div className="header-topic-word">
        <Text as="h1" block className={styles.title}>
          {t("addContact.fullRequest")}
          <br />
          {t("addContact.fullRequest2")}
        </Text>
      </div>
      <Stack horizontal horizontalAlign="center">
        {[...Array(totalSteps).keys()].map((index) => (
          <div key={index} style={{ marginRight: "5px", marginLeft: "5px" }}>
            <div
              style={{
                width: 35,
                height: 35,
                borderRadius: "50%",
                border: "1px solid #000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
                background:
                  initialStep === index + 1
                    ? "var(--accent-color-1)"
                    : "var(--primary-color)",
                color:
                  initialStep === index + 1
                    ? "var(--secondary-color)"
                    : isStepCompleted(index + 1)
                    ? "var(--secondary-color)"
                    : "var(--background-color)",
              }}
            >
              {index + 1}
            </div>
          </div>
        ))}
      </Stack>
      <ProgressBar
        className={styles.container}
        shape="square"
        thickness="large"
        value={
          initialStep === 1
            ? 0.3
            : initialStep === 2
            ? 0.7
            : initialStep === 3
            ? 1.0
            : 0
        }
      />

      {initialStep === 1 && (
        <>
          {savedData && (
            <div
              style={{ color: "var(--secondary-color)" }}
              dangerouslySetInnerHTML={{ __html: savedData.previewText }}
            ></div>
          )}

          <Label className={styles.root}> {t("addContact.firstStep")}</Label>

          <br />
          <Label className={styles.underRoot}>
            {t("addContact.headerDescription")}
          </Label>
        </>
      )}
      {initialStep === 2 && (
        <>
          <Label className={styles.root}> {t("addContact.secendStep")}</Label>
          <br />
          <Label className={styles.underRoot}>
            {t("addContact.pleaseCheck")}
          </Label>
        </>
      )}
      {initialStep === 3 && (
        <>
          <Label className={styles.root}> </Label>
          <br />
        </>
      )}
    </div>
  );
};

export default MultiStepFormforUnSuccess;
